import {IRegionListRegion} from "../actions/fetch_search_regions_action";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchTab} from "../types/SearchTab";

export const getOffersCountFromSearchValue = (value: ISearchInputValue | undefined): number | undefined => {
    if (!value) {
        return undefined;
    }

    if (value.tabType === SearchTab.Regions) {
        // Stats are omitted in ISearchInputRegion type but present at runtime when regions come from API
        const regions = value.regions as unknown as IRegionListRegion[] | undefined;
        const total = regions?.reduce((sum, region) => sum + (region?.stats?.properties_all_count_for_sale ?? 0), 0);
        return total || undefined;
    }

    if (value.tabType === SearchTab.Offers) {
        return value.offer?.stats?.properties_count_for_sale;
    }

    if (value.tabType === SearchTab.Vendors) {
        return value.vendor?.stats?.offers_count_for_sale;
    }

    return undefined;
};
import {IRegionListRegion} from "../actions/fetch_search_regions_action";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchTab} from "../types/SearchTab";

export const getOffersCountFromSearchValue = (value: ISearchInputValue | undefined): number | undefined => {
    if (!value) {
        return undefined;
    }

    if (value.tabType === SearchTab.Regions) {
        // Stats are omitted in ISearchInputRegion type but present at runtime when regions come from API
        const regions = value.regions as unknown as IRegionListRegion[] | undefined;
        const total = regions?.reduce((sum, region) => sum + (region?.stats?.properties_all_count_for_sale ?? 0), 0);
        return total || undefined;
    }

    if (value.tabType === SearchTab.Offers) {
        return value.offer?.stats?.properties_count_for_sale;
    }

    if (value.tabType === SearchTab.Vendors) {
        return value.vendor?.stats?.offers_count_for_sale;
    }

    return undefined;
};
